var _g, _g2, _g3, _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXrp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 763,
    height: 763,
    viewBox: "0 0 763 763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_868_421)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 381.696,
    cy: 381.696,
    r: 228.889,
    transform: "rotate(-22.7969 381.696 381.696)",
    fill: "url(#paint0_linear_868_421)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_868_421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.397,
    y: 293.26,
    width: 219.957,
    height: 312.071,
    transform: "rotate(-22.7969 241.397 293.26)",
    fill: "url(#paint1_linear_868_421)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_868_421)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 374.567,
    cy: 328.592,
    r: 144.747,
    transform: "rotate(-9.11834 374.567 328.592)",
    fill: "url(#paint2_linear_868_421)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 374.567,
    cy: 328.592,
    r: 144.467,
    transform: "rotate(-9.11834 374.567 328.592)",
    stroke: "#52CDFF",
    strokeWidth: 0.559439,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.958 264.667L431.397 260.418L399.696 309.316C388.213 327.016 364.46 332.207 346.63 320.913L297.405 289.701L316.861 285.449L354.246 309.161C359.689 312.596 366.265 313.751 372.552 312.377C378.84 311.003 384.334 307.21 387.848 301.817L411.958 264.667Z",
    fill: "#23292F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.954 396.888L321.501 401.139L353.412 351.938C364.894 334.237 388.647 329.046 406.477 340.341L456.003 371.745L436.563 375.994L398.861 352.093C393.418 348.658 386.843 347.503 380.555 348.877C374.267 350.251 368.773 354.044 365.259 359.436L340.954 396.888Z",
    fill: "#23292F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_868_421",
    x: 0.913849,
    y: 0.913849,
    width: 761.565,
    height: 761.565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75.9169,
    result: "effect1_foregroundBlur_868_421"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_868_421",
    x: 89.5633,
    y: 56.201,
    width: 627.359,
    height: 676.587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75.9169,
    result: "effect1_foregroundBlur_868_421"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_868_421",
    x: 190.638,
    y: 127.88,
    width: 328.697,
    height: 367.858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -39.1607,
    dy: -55.9439
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.7653
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3125 0 0 0 0 0.3125 0 0 0 0 0.3125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_868_421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.3547
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.975 0 0 0 0 0.975 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_868_421",
    result: "effect2_innerShadow_868_421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.4128
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_868_421",
    result: "effect3_innerShadow_868_421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_868_421",
    x1: 381.696,
    y1: 152.807,
    x2: 381.696,
    y2: 610.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_868_421",
    x1: 351.375,
    y1: 293.26,
    x2: 351.375,
    y2: 605.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_868_421",
    x1: 239.675,
    y1: 272.541,
    x2: 410.291,
    y2: 343.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.0e10692fa071f27b011f2744b1b12d33.svg";
export { ForwardRef as ReactComponent };